import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import UserDashboardList from '../features/user/UserDashboardList';
import { useTranslation } from 'react-i18next';

export default function UserSideBar({ ordersCount, paymentCount, CartCount, FavCount }) {
    const [isOpen, setIsOpen] = useState(false);
    const { i18n } = useTranslation();
    function toggleMenu() { setIsOpen(!isOpen) };

    return (
        <div className="mt-5">
            <div className={`d-block d-sm-none slide-menu-container ${isOpen ? 'open' : ''} ${i18n.language === "ar" ? "slide-menu-container-Ar" : "slide-menu-container-En"}`}>
                <div className="text-end bg-light-orange text-white fs-6 rounded pe-2 pt-1" onClick={toggleMenu}>
                    {isOpen ? <FontAwesomeIcon icon={faCircleXmark} /> : <FontAwesomeIcon icon={faEllipsis} />}
                </div>
                <div className="px-5">
                    <ul
                        className="list-group pt-2">
                        <UserDashboardList
                            ordersCount={ordersCount}
                            paymentCount={paymentCount}
                            CartCount={CartCount}
                            FavCount={FavCount}
                        />
                    </ul>
                </div>
            </div>
            <div className="d-none d-sm-flex flex-wrap justify-content-between">
                <ul
                    className="list-group pt-2 w-100">
                    <UserDashboardList
                        ordersCount={ordersCount}
                        paymentCount={paymentCount}
                        CartCount={CartCount}
                        FavCount={FavCount}
                    />
                </ul>
            </div>
        </div>
    )
}
